import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import GenericTile from './GenericTile';
import Pencil from '../../../assets/images/Pencil';

const UpdateQuestionnaireTile = ({ buttonSize, fullHeight }) => {
    const redirectToHub = () => window.location.replace('/usis/advice/fps/profile');
    const smallScreenSize = window.matchMedia("(max-width: 600px)");

    const [smallScreen, setSmallScreen] = React.useState(window.innerWidth <= 600 ? true : false);

    smallScreenSize.addEventListener('change', function () {
        setSmallScreen(smallScreenSize)
    })


    return (
        <GenericTile
            buttonVariant='secondary'
            title='Update Your Questionnaire'
            description='Provide more detail for your advisor or update your information in the comprehensive questionnaire.'
            buttonText='Update Information'
            id='update-questionnaire'
            buttonSize={buttonSize}
            buttonIcon={<Pencil />}
            smallScreenSize={smallScreen}
            onClick={redirectToHub}
            fullHeight={fullHeight}
        />
    )
}

export default UpdateQuestionnaireTile;



